<div class="container">
    <form class="snmp-container" [formGroup]="form">
        <div class="snmp-form-field">
            <mat-label>Enabled</mat-label>
            <div class="snmp-input">
                <mat-slide-toggle formControlName="Enabled">
                    {{ form.get('Enabled')?.value ? 'On' : 'Off' }}
                </mat-slide-toggle>
            </div>
        </div>
        <div class="snmp-form-field">
            <mat-label>Username</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <input matInput formControlName="Username">
                    @if(form.get('Username')?.hasError('required')) {
                    <mat-error>Required</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="snmp-form-field">
            <mat-label>Access Mode</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <mat-select matInput formControlName="Rights">
                        <mat-option value="ro">Read Only</mat-option>
                        <mat-option value="rw">Read Write</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="snmp-form-field">
            <mat-label>MiB subtree</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <input matInput formControlName="MibAccess">
                </mat-form-field>
            </div>
        </div>
        <div class="snmp-form-field">
            <mat-label>Security Level</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <mat-select formControlName="SecLevel">
                        <mat-option value="auth">Auth</mat-option>
                        <mat-option value="priv">Priv</mat-option>
                        <mat-option value="noauth">No Auth</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        @if (form.get('SecLevel')?.value !== null && form.get('SecLevel')?.value !== 'noauth') {
        <div class="snmp-form-field">
            <mat-label>Authentication Type</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <mat-select formControlName="AuthType">
                        <mat-option value="MD5">MD5</mat-option>
                        <mat-option value="SHA">SHA</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="snmp-form-field">
            <mat-label>Authentication Passphrase</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <input matInput type="password" formControlName="AuthPass">
                    @if(form.get('AuthPass')?.hasError('required')) {
                    <mat-error>Required</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        @if (form.get('SecLevel')?.value !== 'auth') {
        <div class="snmp-form-field">
            <mat-label>Privacy Type</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <mat-select formControlName="PrivType">
                        <mat-option value="DES">DES</mat-option>
                        <mat-option value="AES">AES</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="snmp-form-field">
            <mat-label>Privacy Passphrase</mat-label>
            <div class="snmp-input">
                <mat-form-field [subscriptSizing]="'dynamic'">
                    <input matInput type="password" formControlName="PrivPass">
                    @if(form.get('PrivPass')?.hasError('required')) {
                    <mat-error>Required</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        }
        }
    </form>
    <div class="buttons">
        <button class="cancel-button" mat-raised-button (click)="close(false)">Cancel</button>
        <button class="save-button" mat-raised-button (click)="close(true)" [disabled]="form.invalid">Save</button>
    </div>
</div>